'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validateOptions = require('./validateOptions');

var _validateOptions2 = _interopRequireDefault(_validateOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _validateOptions2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-utils/dist/index.js
// module id = oDSQ
// module chunks = 11